
import {POSTED_JOB_VIEW_REQUEST, POSTED_JOB_VIEW_SUCCESS,POSTED_JOB_VIEW_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const PostedJobViewAction = (data) => {
    return function (dispatch) {
      dispatch({
        type: POSTED_JOB_VIEW_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_job_by_vendorId?vendorId=${data.id}&jobsPostedStatus=${data.posted}&pageNumber=${data?.pageNumber}&pageSize=10&search=${data.search}&designation=${data?.designationSendapi || []}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: POSTED_JOB_VIEW_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: POSTED_JOB_VIEW_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };